
import objectPath from 'object-path'
import { camelCase } from '@/utils/helpers'
import initialStateHotel from '../hotels/initialState'
import initialStateInsurance from '../insurances/initialState'
import initialStateTransfer from '../transfers/initialState'
import initialStateFlight from '../flights/initialState'

const initialState = {
  hotels: initialStateHotel,
  insurances: initialStateInsurance,
  transfers: initialStateTransfer,
  flights: initialStateFlight
}

const mutations = {
  setActualize(state, { actualizeId }) {
    if (state.actualize.id === actualizeId) {
      state.actualize = {
        ...state.actualize,
        type: 'success',
        status: 'loadingAllowed'
      }
    }
  },
  setActualizeTourResearch(state, { actualizeId, errors }) {
    if (state.actualize.id === actualizeId) {
      state.actualize = {
        ...state.actualize,
        type: 'tourResearch',
        status: 'stop',
        errors: errors.map(({ title, detail }) => `${title}: ${detail}`)
      }
    }
  },
  setActualizeServiceError(state, { service, serviceIndex }) {
    const targets = {
      hotels: {
        idField: 'id',
        name: 'hotels',
        current: `hotels.${serviceIndex}.accommodations.current`,
        collection: `hotels.${serviceIndex}.accommodations.collection`
      },
      flights: {
        idField: 'id',
        name: 'flights',
        current: `flights.${serviceIndex}.aviatickets.current`,
        collection: `flights.${serviceIndex}.aviatickets.collection`
      },
      transfers: {
        idField: 'slug',
        name: 'transfers',
        current: `transfers.${serviceIndex}.transfers.current`,
        collection: `transfers.${serviceIndex}.transfers.collection`
      },
      insurances: {
        idField: 'slug',
        name: 'insurances',
        current: `insurances.${serviceIndex}.insurances.current`,
        collection: `insurances.${serviceIndex}.insurances.collection`
      }
    }

    const {
      idField,
      name,
      current,
      collection
    } = targets[service]

    const id = objectPath.get(state, `${current}.${idField}`)
    const oldCollection = objectPath.get(state, collection)
    const newCollection = oldCollection.filter(item => (
      item[idField] !== id && item[idField] !== null
    ))

    let newCurrent = objectPath.get(initialState[name](), current.replace(`${name}.${serviceIndex}.`, ''))

    if (newCollection.length) {
      newCurrent = newCollection[0]
    } else {
      state.actualize = {
        ...state.actualize,
        type: 'research',
        errorsServices: [
          ...state.actualize.errorsServices,
          {
            service,
            serviceIndex
          }
        ]
      }
    }

    objectPath.set(state, collection, newCollection)
    objectPath.set(state, current, newCurrent)
  },
  setActualizeFatalError(state, { actualizeId, errors }) {
    if (state.actualize.id === actualizeId) {
      state.actualize = {
        ...state.actualize,
        type: 'fatalError',
        status: 'stop',
        errors: errors.map(({ title, detail }) => `${title}: ${detail}`)
      }
    }
  },
  setActualizeValidateError(state, { actualizeId, errors }) {
    if (state.actualize.id === actualizeId) {
      state.actualize = {
        ...state.actualize,
        type: 'validateError',
        status: 'stop',
        errors: errors.map(({ title, detail }) => `${title}: ${detail}`)
      }
    }
  },
  setActualizeError(state, { actualizeId, errors }) {
    if (state.actualize.id === actualizeId) {
      state.actualize = {
        ...state.actualize,
        status: 'stop'
      }

      for (const key in errors) {
        if (Object.prototype.hasOwnProperty.call(errors, key)) {
          const services = errors[key]

          services.forEach((service) => {
            state.actualize.errors = [
              ...state.actualize.errors,
              ...service.errors
            ]
            this.commit(`cart/${key}Actualize`, service)
          })
        }
      }
    }
  },
  hotelsActualize(state, { code, ...data }) {
    code.forEach((errorCode) => {
      const mutationName = camelCase(`hotels_${errorCode}`)
      this.commit(`cart/${mutationName}`, {
        errorCode,
        ...data
      })
    })
  },
  hotelsServiceUnavailable(state, { errorCode, accommodationId }) {
    state.actualize.type = errorCode

    const hotelIndex = state.hotels.findIndex(hotel => (
      hotel.accommodations.current.id === accommodationId
    ))

    state.actualize = {
      ...state.actualize,
      type: 'notActual',
      status: 'stop'
    }

    this.commit('cart/setActualizeServiceError', {
      service: 'hotels',
      serviceIndex: hotelIndex
    })
  },
  hotelsCriticalError(state, { errorCode, accommodationId }) {
    state.actualize.type = errorCode

    const hotelIndex = state.hotels.findIndex(hotel => (
      hotel.accommodations.current.id === accommodationId
    ))

    state.actualize = {
      ...state.actualize,
      type: 'research',
      status: 'stop',
      errorsServices: [
        ...state.actualize.errorsServices,
        {
          service: 'hotels',
          serviceIndex: hotelIndex
        }
      ]
    }
  },
  hotelsPriceChange(state, { errorCode, price, accommodationId }) {
    state.actualize.type = errorCode

    const hotel = state.hotels.find(hotelItem => (
      hotelItem.accommodations.current.id === accommodationId
    ))
    const id = hotel.accommodations.current.id

    hotel.accommodations.current.price = price

    hotel.accommodations.collection
      .find(accommodation => accommodation.id === id)
      .price = price
  },
  hotelsMealChange(state, { errorCode, meals, accommodationId }) {
    state.actualize.type = errorCode

    const hotel = state.hotels.find(hotelItem => (
      hotelItem.accommodations.current.id === accommodationId
    ))
    const id = hotel.accommodations.current.id

    hotel.accommodations.current.meals = meals

    hotel.accommodations.collection
      .find(accommodation => accommodation.id === id)
      .meals = meals
  },
  hotelsRoomChange(state, { errorCode, room, accommodationId }) {
    state.actualize.type = errorCode

    const hotel = state.hotels.find(hotelItem => (
      hotelItem.accommodations.current.id === accommodationId
    ))
    const id = hotel.accommodations.current.id

    hotel.accommodations.current.room = room

    hotel.accommodations.collection
      .find(accommodation => accommodation.id === id)
      .room = room
  },
  flightsActualize(state, { code, ...data }) {
    code.forEach((errorCode) => {
      const mutationName = camelCase(`flights_${errorCode}`)
      this.commit(`cart/${mutationName}`, {
        errorCode,
        ...data
      })
    })
  },
  flightsServiceUnavailable(state, { errorCode, id }) {
    state.actualize.type = errorCode

    const flightIndex = state.flights.findIndex(flight => (
      flight.aviatickets.current.id === id
    ))

    state.actualize = {
      ...state.actualize,
      type: 'notActual',
      status: 'stop'
    }

    this.commit('cart/setActualizeServiceError', {
      service: 'flights',
      serviceIndex: flightIndex
    })
  },
  flightsCriticalError(state, { errorCode, id }) {
    state.actualize.type = errorCode

    const flightIndex = state.flights.findIndex(flight => (
      flight.aviatickets.current.id === id
    ))

    state.actualize = {
      ...state.actualize,
      type: 'research',
      status: 'stop',
      errorsServices: [
        ...state.actualize.errorsServices,
        {
          service: 'flights',
          serviceIndex: flightIndex
        }
      ]
    }
  },
  flightsPriceChange(state, { errorCode, price, id }) {
    state.actualize.type = errorCode

    const flight = state.flights.find(flightItem => (
      flightItem.aviatickets.current.id === id
    ))
    flight.aviatickets.current.price = price

    const aviaticketId = state.aviaticket.aviatickets.current.id

    flight.aviatickets.collection
      .find(aviaticket => aviaticket.id === aviaticketId)
      .price = price
  },
  transfersActualize(state, { code, ...data }) {
    code.forEach((errorCode) => {
      const mutationName = camelCase(`transfers_${errorCode}`)
      this.commit(`cart/${mutationName}`, {
        errorCode,
        ...data
      })
    })
  },
  transfersServiceUnavailable(state, { errorCode, vehicleId }) {
    state.actualize.type = errorCode

    const transferIndex = state.transfers.findIndex(transfer => (
      transfer.transfers.current.vehicleId === vehicleId
    ))

    state.actualize = {
      ...state.actualize,
      type: 'notActual',
      status: 'stop'
    }

    this.commit('cart/setActualizeServiceError', {
      service: 'transfers',
      serviceIndex: transferIndex
    })
  },
  transfersCriticalError(state, { errorCode, vehicleId }) {
    state.actualize.type = errorCode

    const transferIndex = state.transfers.findIndex(transfer => (
      transfer.transfers.current.vehicleId === vehicleId
    ))

    state.actualize = {
      ...state.actualize,
      type: 'research',
      status: 'stop',
      errorsServices: [
        ...state.actualize.errorsServices,
        {
          service: 'transfers',
          serviceIndex: transferIndex
        }
      ]
    }
  },
  transfersPriceChange(state, { errorCode, price, vehicleId }) {
    state.actualize.type = errorCode

    const transfer = state.transfers.find(transferItem => (
      transferItem.transfers.current.vehicleId === vehicleId
    ))
    const slug = transfer.transfers.current.slug

    transfer.transfers.current.price = price
    transfer.transfers.collection
      .find(transferItem => transferItem.slug === slug)
      .price = price
  },
  transfersVehicleChange(state, { errorCode, oldVehicleId, vehicleId }) {
    state.actualize.type = errorCode
    const transfer = state.transfers.find(transferItem => (
      transferItem.transfers.current.vehicleId === oldVehicleId
    ))
    const slug = transfer.transfers.current.slug

    transfer.transfers.current.vehicleId = vehicleId
    transfer.transfers.collection
      .find(transferItem => transferItem.slug === slug)
      .vehicleId = vehicleId
  },
  insurancesActualize(state, { code, ...data }) {
    code.forEach((errorCode) => {
      const mutationName = camelCase(`insurances_${errorCode}`)
      this.commit(`cart/${mutationName}`, {
        errorCode,
        ...data
      })
    })
  },
  insurancesServiceUnavailable(state, { errorCode, id }) {
    state.actualize.type = errorCode

    const insuranceIndex = state.insurances.findIndex(insurance => (
      insurance.insurances.current.slug === id
    ))

    state.actualize = {
      ...state.actualize,
      type: 'notActual',
      status: 'stop'
    }

    this.commit('cart/setActualizeServiceError', {
      service: 'insurances',
      serviceIndex: insuranceIndex
    })
  },
  insurancesCriticalError(state, { errorCode, id }) {
    state.actualize.type = errorCode

    const insuranceIndex = state.insurances.findIndex(insurance => (
      insurance.insurances.current.slug === id
    ))

    state.actualize = {
      ...state.actualize,
      type: 'research',
      status: 'stop',
      errorsServices: [
        ...state.actualize.errorsServices,
        {
          service: 'insurances',
          serviceIndex: insuranceIndex
        }
      ]
    }
  },
  insurancesPriceChange(state, { errorCode, price, id }) {
    state.actualize.type = errorCode
    const insurance = state.insurances.find(insuranceItem => (
      insuranceItem.insurances.current.slug === id
    ))
    const slug = insurance.insurances.current.slug

    insurance.insurances.current.price = price
    insurance.insurances.collection
      .find(insuranceItem => insuranceItem.slug === slug)
      .price = price
  },
  setActualizeStatus(state, payload) {
    state.actualize.status = payload
  },
  setActualizeType(state, payload) {
    state.actualize.type = payload
  },
  clearActualizeErrorsMessages(state) {
    state.actualize = {
      ...state.actualize,
      type: 'success',
      status: 'loadingAllowed',
      errors: [],
      errorsServices: []
    }
  },
  incrementActualizeId(state) {
    state.actualize = {
      ...state.actualize,
      id: state.actualize.id += 1
    }
  },
}

export default mutations